/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { ListeContainer, useListe } from '@mairistem/liste';

import type { Profession } from '@/types';

import ProfessionListe from './ProfessionListe';

interface Props {
  /** Callback appelé lors de la sauvegarde (liste en saisie) */
  onSave?: (qualification: Profession) => void;
  /** Callback appelé lors de la sélection d'une ligne */
  onSelect?: (qualification: Profession) => void;
  /** Diplôme sélectionné */
  selectedItem?: Profession;
  /** Callback appelé lors du reset de l'item */
  resetSelectedItem?: (qualification: Profession) => void;
  /** Booléen pour gérer l'affichage des professions caduques */
  isShowingCaduque?: boolean;
}

const ProfessionListeContainer = (props: Props) => {
  const {
    selectedItem = {},
    onSave = null,
    onSelect = null,
    resetSelectedItem = null,
    isShowingCaduque = false,
  } = props;

  const [service] = useListe('/api/transverse/professions', {
    identifiantDomaine: 1,
    ...(!isShowingCaduque ? { caduque: false } : {}),
  });

  return (
    <ListeContainer
      service={service}
      type="professions"
      contains="liste"
      perPage={50}
    >
      <ProfessionListe
        onSave={onSave}
        onSelect={onSelect}
        selectedProfession={selectedItem}
        resetSelectedItems={resetSelectedItem}
        isShowingCaduque={isShowingCaduque}
      />
    </ListeContainer>
  );
};

export default ProfessionListeContainer;
